var jade = require("/home/circleci/rentapplication-frontend/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div id=\"view-report-modal\" style=\"max-width: 100vw;\" class=\"popup\"><div ng-style=\"{'background': theme_color}\" class=\"head\"><a title=\"Close\" href=\"#\" ng-click=\"$dismiss()\" class=\"fancybox-item fancybox-close\"></a></div><div class=\"container\"><div class=\"image-popup\"><img ng-if=\"toggle_1\"" + (jade.attr("src", require('./tr/Sample-Credit-Report.png'), true, true)) + " alt=\"\"><img ng-if=\"toggle_2\"" + (jade.attr("src", require('./tr/Sample-Criminal-Report.png'), true, true)) + " alt=\"\"><img ng-if=\"toggle_3\"" + (jade.attr("src", require('./tr/Sample-Eviction-Report.png'), true, true)) + " alt=\"\"></div></div></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./components/home/landing/report-modal.jade
// module id = 652
// module chunks = 0